import DefaultLayout from "@/layouts/DefaultLayout";
import KCustomerAddressesTable from "kinnect-front/KCustomers/KCustomerAddressesTable";
import KCustomerForm from "kinnect-front/KCustomers/KCustomerForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { Customer } from "kinnect-models";
import { KActionDialog } from "kinnect-general";
import { VCard } from "vuetify/lib";

export default {
	name: "CustomerPage",

	metaInfo() {
		const title = this.editing && this.fetched
			? `Customers - ${this.customer.name}`
			: "Customers - Add a Customer";

		return { title: this.fetched ? title : null };
	},

	props: { idCustomer: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "customers",
		customer: null,
		deleteDialogOpen: false
	} ),

	computed: {
		editing() {
			return Boolean( this.idCustomer );
		},

		genDeleteDialog() {
			if ( this.editing && this.customer && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete customer" )}
					onConfirm={() => this.customer.delete()}
					redirect={[ "back", { name: "customers" } ]}
					title="Delete Customer"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the customer <strong>{this.customer.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Customer",
					tooltip: "Delete this customer"
				};
			}
		}
	},

	methods: {
		async fetchCustomer() {
			if ( this.editing ) {
				this.customer = await Customer.findPageModel( this.idCustomer );
			}
		},

		async fetch() {
			await this.fetchCustomer();
		}
	},

	render() {
		return <DefaultLayout maxWidth={this.editing ? "800px" : "600px" }>
			<KCustomerForm
				customer={this.customer}
				loading={this.$wait.is( "find customer" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
			></KCustomerForm>

			{this.editing && <VCard class="mt-4">
				<KCustomerAddressesTable
					idCustomer={this.idCustomer}
					items={this.customer ? this.customer.addresses : []}
					loading={this.$wait.is( "find customer" )}
				>
					<template slot="title">Addresses for {this.customer ? this.customer.name : "..."}</template>
				</KCustomerAddressesTable>
			</VCard>}

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
